import { render, staticRenderFns } from "./message_modify.vue?vue&type=template&id=32643aa4&scoped=true&"
import script from "./message_modify.vue?vue&type=script&lang=js&"
export * from "./message_modify.vue?vue&type=script&lang=js&"
import style0 from "./message_modify.vue?vue&type=style&index=0&id=32643aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32643aa4",
  null
  
)

export default component.exports